<template>
  <div class="student-section" ref="self">
      <img :src="images.student" style="display: block" @load="emitReady">
      <!-- 数字部分，需要动画 -->
      <span class="num1" id="num1">34</span>
      <span class="num2" id="num2">10.1</span>
      <span class="num3" id="num3">5.0</span>
      <span class="num4" id="num4">82</span>
      <span class="num5" id="num5">26</span>
      <span class="num6" id="num6">34</span>
      <!-- 轮播图 -->
      <div class="swiper-item">
        <div class="swiper-wrapper">
            <!-- 在部分iphone机型上（我没有），经过观察，
            直接使用img会有时出不来部分图片，把它包在div中就能了，不知道什么原因 -->
            <div class="swiper-slide">
                <img :src="images.student01" />
            </div>
            <div class="swiper-slide">
                <img :src="images.student02" />
            </div>
            <div class="swiper-slide">
                <img :src="images.student03" />
            </div>
            <div class="swiper-slide">
                <img :src="images.student04" />
            </div>
            <div class="swiper-slide">
                <img :src="images.student05" />
            </div>
            <div class="swiper-slide">
                <img :src="images.student06" />
            </div>
        </div>
        <button class="swiper-button-prev"></button>
        <button class="swiper-button-next"></button>
        </div>
  </div>
</template>

<script>
import images from '@/utils/images.js'
import active from './active.js'
export default {
    mixins: [active],
    data () {
        return {
            images: images,
            index: 3
            // ticking: true
        }
    },
    mounted () {
        window.addEventListener('scroll', this.scroll)
        new window.Swiper('.swiper-item', {
            loop: true,
            autoplay: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        })
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.scroll)
    },
    methods: {
        scroll () {
            let scrollY = window.scrollY
            let offsetTop = this.$refs.self.offsetTop
            // console.log('scrollY:', scrollY, ',offset:', offsetTop);
            if (/*this.ticking && */scrollY > offsetTop - 500) {
                window.removeEventListener('scroll', this.scroll)
                window.requestAnimationFrame(() => {
                    // this.ticking = false
                    var options = {
                        useEasing: true, // 使用缓和
                        useGrouping: true, // 使用分组(是否显示千位分隔符,一般为 true)
                    }
                    const decimal = 1;
                    new window.CountUp('num1', 0, 34, 0, 1.5, options).start()
                    new window.CountUp('num2', 0, 10.1, decimal, 1.5, options).start()
                    new window.CountUp('num3', 0, 5.0, decimal, 1.5, options).start()
                    new window.CountUp('num4', 0, 82, 0, 1.5, options).start()
                    new window.CountUp('num5', 0, 26, 0, 1.5, options).start()
                    new window.CountUp('num6', 0, 34, 0, 1.5, options).start()
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.student-section {
    position: relative;
    .num1, .num2, .num3, .num4, .num5, .num6 {
        position: absolute;
        font-size: 60px;
        color: #ab8560;
        font-weight: bold;
    }
    .num1, .num2, .num3 {
        top: 342px;
    }
    .num4, .num5, .num6 {
        top: 618px;
    }
    .num1 {
      right: 600px;
    }
    .num2 {
        right: 354px;
    }
    .num3 {
        right: 116px;
    }
    .num4 {
        right: 600px;
    }
    .num5 {
        right: 364px;
    }
    .num6 {
        right: 126px;
    }

    .swiper-item {
        position: absolute;
        bottom: 82px;
        width: 100%;
        overflow: hidden;
    }
    .swiper-button-prev, .swiper-button-next {
        background-size: 100%!important;
        background-color: transparent;
        outline: none;
        border: none;
        width: 60px!important;
        padding: 0;
        box-sizing: content-box;
    }
    .swiper-button-prev {
        background-image: url("https://fmbamartech.ceibs.edu/fmba-h5/fmba-intro/img/icon_left.png")!important;
        left: 10px;
    }
    .swiper-button-next {
        background-image: url("https://fmbamartech.ceibs.edu/fmba-h5/fmba-intro/img/icon_right.png")!important;
        background-color: transparent;
        right: 10px;
    }
}
</style>